// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'shield-lock';

export const Component = () => (
  <g fill='none' stroke='currentColor'>
    <g strokeLinecap='round' strokeLinejoin='round'>
      <path d='M11.656 7.406H6.344c-.587 0-1.063.476-1.063 1.063v3.187c0 .587.476 1.063 1.063 1.063h5.312c.587 0 1.063-.476 1.063-1.063V8.47c0-.587-.476-1.063-1.063-1.063zm-5.312 0V5.813a2.656 2.656 0 0 1 5.312 0v1.593' />
      <path d='M9 16.969c-4.729-1.262-7.969-4.066-7.969-9.031V1.03H16.97v6.907c0 4.961-3.235 7.768-7.969 9.03z' />
    </g>
    <path d='M9 10.328a.266.266 0 1 1 0-.531m0 .531a.266.266 0 1 0 0-.531' />
  </g>
);

export const viewBox = '0 0 18 18';
